import Vue from 'vue'
import { SwipeCell, Button, Cell } from 'vant'
// 在使用组件的地方
import 'vant/es/button/style';
import 'vant/es/swipe-cell/style';

// 注册组件
Vue.use(SwipeCell)
Vue.use(Button)
Vue.use(Cell)
